module.exports = __webpack_public_path__ + "img/warning.600d2281.png";